import { containerScoped } from '~/decorators/dependency-container'
import { inject } from 'tsyringe'
import RequestBuilder from '~/builders/http/RequestBuilder'

@containerScoped()
export default class SearchClassifiedByIdService {
  constructor(
    @inject(RequestBuilder)
    private requestBuilder: RequestBuilder
  ) {}

  search(
    classifiedId: number
  ): Promise<{
    url: string
  }> {
    return this.requestBuilder
      .request('post', '/api/search-classified-by-id/')
      .data({ classified_id: classifiedId })
      .send()
  }
}
